<template>
    <div class="gobuy-head" v-if="!$IFR.is_iframe">

        <div class="logo">
            <img src="../assets/image/logo1.png" alt="" />
        </div>

        <div class="common-header-wrap">
            <mt-header :title="title" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>

    </div>
</template>
  
<script>
export default {
    name: "GoBuyHead",
    data() {
        return {
        };
    },
    props: {
        title: { type: String, default: '' },
    },
    components: {
    },
    created: function () {
    },
    methods: {
    },
};
</script>
<style lang="scss" scoped>
.gobuy-head {
    width: 100%;
    height: 4.2rem;
    position: fixed;
    z-index: 99;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    background-image: url("../assets/image/homeHbgc.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;

    .logo {
        // position: fixed;
        top: 25px;
        left: 12px;
        z-index: 99;
        margin: .5rem 0;

        img {
            width: 3.5rem;
        }
    }

    .common-header-wrap {
        z-index: 10;
        // position: fixed;
        top: 54px;
        width: 100%;

        .common-header {
            color: #fff;
            box-shadow: none;
            background-color: #F15E60;
        }
    }

    .zhwnwei {
        height: 4.76rem;
    }
}
</style>
  